import React, { useEffect } from 'react'
import { Stack, useRouter } from 'expo-router'
import { useAuth } from '../../hooks/useAuth'

export default function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      router.replace('/(app)')
    }
  }, [isAuthenticated, isLoading, router])

  // gestureEnabled:false — swipe-back is disabled app-wide (see app/_layout).
  return <Stack screenOptions={{ headerShown: false, gestureEnabled: false }} />
}
